import {FinancialCreditType, LOCALE_DATE_TIME_HUMAN_FORMAT, SegmentCode} from "../../config";

const getBillingCustomerId = (raFetchedData: any) => {
    if (raFetchedData.financialInfo.segment === SegmentCode.retail ||
        ([SegmentCode.replacement, SegmentCode.corporate, SegmentCode.tourOperator].includes(raFetchedData.financialInfo.segment) &&
        [FinancialCreditType.fullCredit, FinancialCreditType.noCredit].includes(raFetchedData.financialInfo.creditType))
    ) {
        return raFetchedData?.billingOwner?.customerId;
    }
    else if ([SegmentCode.replacement, SegmentCode.corporate, SegmentCode.tourOperator].includes(raFetchedData.financialInfo.segment) &&
        [FinancialCreditType.standardCredit].includes(raFetchedData.financialInfo.creditType)
    ) {
        return raFetchedData?.secondBillingOwner?.customerId;
    }
    return null;
}

/**
 * Check if effective drop-off date is changed
 * @param effectiveDateTime
 * @param now
 * @return false - isn't, true - is
 */
const isEffectiveDateChanged = (effectiveDateTime: any, now: any): boolean => {
    if (effectiveDateTime.format(LOCALE_DATE_TIME_HUMAN_FORMAT) !== now.format(LOCALE_DATE_TIME_HUMAN_FORMAT)) {
        return true;
    }
    return false;
}

const getInsertionFlow = (checkOutInMode: 'in' | 'subIn' | 'out' | 'oprOut' | 'oprIn' | 'ddt' | 'dataUpd') => {
    switch (checkOutInMode) {
        case 'in':
        case 'subIn':
            return "CHECKIN";
            break;
		case 'oprIn':
            return "CHECKIN";
            break;
        case 'out':
            return "CHECKOUT";
            break;
		case 'oprOut':
            return "CHECKOUT";
            break;
        case 'ddt':
            return "DDT";
            break;
        case 'dataUpd':
            return "UPDATE_VEHICLE_DATA";
            break;
    }
    return;
}

export {
    getBillingCustomerId,
    isEffectiveDateChanged,
    getInsertionFlow
}